/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-30 11:47:31
 */

export default  {
  path: 'openapi_server',
  component: () => import(/* webpackChunkName: "openapiServer-list" */ '@/pages/openapiServer/ServerList'),
  meta: {title:'接口管理',cate:'所有商户管理'},
  children: [
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "openapiServer-create" */ '@/pages/openapiServer/CreateEdit'),
      meta: {title:'添加配置'},
    },
    {
      path: ':openapi_server/edit',
      component: () => import(/* webpackChunkName: "openapiServer-edit" */ '@/pages/openapiServer/CreateEdit'),
      meta: {title:'编辑配置'},
    },
    {
      path: ':openapi_server_id/view',
      component: () => import(/* webpackChunkName: "openapiServer-view" */ '@/pages/openapiServer/CreateEdit'),
      meta: {title:'查看配置'},
    }
  ]
}